import PropTypes from "prop-types";

import LeadStatusBadge from "routes/leads/swoogo_registrants/LeadStatusBadge";
import useSwoogoRegistrantLeads from "routes/leads/swoogo_registrants/useSwoogoRegistrantLeads";

// Every cell asks for the leads of the whole page, so the page loads them with
// one shared request.
const RegistrantLeadStatusCell = ({ registrantId, pageRegistrantIds }) => {
  const { leadsByRegistrant } = useSwoogoRegistrantLeads(pageRegistrantIds);
  const status = leadsByRegistrant.get(registrantId)?.lead?.status;
  return status ? <LeadStatusBadge status={status} /> : "—";
};

RegistrantLeadStatusCell.propTypes = {
  registrantId: PropTypes.number.isRequired,
  pageRegistrantIds: PropTypes.arrayOf(PropTypes.number).isRequired,
};

export const REGISTRANT_LEAD_STATUS_COLUMN = {
  id: "Meta Status",
  header: "Meta Status",
  size: 160,
  enableSorting: false,
  cell: ({ row, table }) => (
    <RegistrantLeadStatusCell
      registrantId={row.original.id}
      pageRegistrantIds={table
        .getRowModel()
        .rows.map(pageRow => pageRow.original.id)}
    />
  ),
};
